import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: Service Worker registreren — MAAR uitschakelen op preview/development
// Op .preview.emergentagent.com hadden we recurrente cache-loops. Beter geen SW daar.
const isPreview = typeof window !== 'undefined' && /\.preview\.emergentagent\.com$/.test(window.location.hostname);

if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', async () => {
    try {
      // Op preview/dev: deregistreer ALLE service workers en wis ALLE caches → schone slate
      if (isPreview) {
        const regs = await navigator.serviceWorker.getRegistrations();
        for (const r of regs) {
          try { await r.unregister(); } catch (_) { /* stil */ }
        }
        if ('caches' in window) {
          const keys = await caches.keys();
          await Promise.all(keys.map(k => caches.delete(k)));
        }
        return; // geen SW registreren op preview
      }

      // Productie: wis oude cache-versies (houdt enkel v6 aan)
      if ('caches' in window) {
        const keys = await caches.keys();
        const oud = keys.filter(k => !k.startsWith('emergent-billing-v6'));
        if (oud.length > 0) {
          await Promise.all(oud.map(k => caches.delete(k)));
          const wasReload = sessionStorage.getItem('__sw_cache_cleared');
          if (!wasReload) {
            sessionStorage.setItem('__sw_cache_cleared', '1');
            window.location.reload();
            return;
          }
        }
      }
      // Deregistreer elke SW die niet /sw.js is (of die vast zit op oude versie)
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        if (!r.active || !r.active.scriptURL.endsWith('/sw.js')) {
          await r.unregister();
        }
      }
    } catch { /* stil */ }

    // Productie: registreer SW
    if (!isPreview) {
      navigator.serviceWorker.register('/sw.js').then((reg) => {
        setInterval(() => { reg.update().catch(() => {}); }, 10 * 60 * 1000);
        if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) {
              window.location.reload();
            }
          });
        });
      }).catch(() => { /* niet kritiek */ });
    }
  });
}
